import * as React from "react";

import { IDispatchAction } from "../../types";

type actionTypes =
  | "SET-ENTITY-ID"
  | "CURRENT-ACTION"
  | "ACTION-OPTIONS"
  | "SET-VALUE"
  | "SET-SUBMITTING"
  | "SET-SUCCESS"
  | "SET-ERROR"
  | "SET-RECON"
  | "SET-USER-STATUS";

export const initialState: {
  currentAction: "NEW" | "VIEW" | "EDIT";
  entityId: "";
  actionOptions: { allowedActions: Array<string>; disableAll?: boolean };
  setValue: (key: string, value: any) => void;
  reset: () => void;
  error: any;
  submitting: boolean;
  successMessage: string;
} = {
  currentAction: "NEW",
  entityId: "",
  actionOptions: {
    allowedActions: [],
    disableAll: true,
  },
  setValue: () => {},
  reset: () => {},
  submitting: false,
  error: "",
  successMessage: "",
};

export const QuerySetCVMContext = React.createContext<{
  state: typeof initialState;
  dispatch: React.Dispatch<IDispatchAction<actionTypes>>;
}>({
  state: initialState,
  dispatch: () => {},
});

export function reducer(state: any, action: IDispatchAction<actionTypes>) {
  switch (action.type) {
    case "SET-ENTITY-ID":
      return { ...state, entityId: action.value };
    case "CURRENT-ACTION":
      return { ...state, currentAction: action.value };
    case "ACTION-OPTIONS":
      return { ...state, actionOptions: action.value };
    case "SET-VALUE":
      return { ...state, setValue: action.value };
    case "SET-SUBMITTING":
      return { ...state, submitting: action.value };
    case "SET-SUCCESS":
      return { ...state, successMessage: action.value };
    case "SET-ERROR":
      return { ...state, error: action.value };
    case "SET-RECON":
      return { ...state, recon: action.value };
    case "SET-USER-STATUS":
      return { ...state, userStatus: action.value };
    default:
      return state;
  }
}
